import CheckMark from 'components/utils/icons/CheckMark';
import React from 'react';
import styled, { css } from 'styled-components';
import {
	media,variables
} from 'styleUtils';

const Container = styled.div`
  display: flex;
  .switch {
    display: inline-block;
    height: 34px;
    position: relative;
    width: 60px;
    ${media.desktop`
      height: 20px;
    `}
  }

  .switch input {
    display:none;
  }

  .slider {
    background-color: ${props => props.color ? variables.white : '#ccc'};
    bottom: 0;
    cursor: pointer;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: .4s;
    border-radius: 34px;

    &:before {
      border-radius: 50%;
      background-color: ${props => props.color ? variables[props.color] : '#fff'};
      bottom: 4px;
      content: "";
      height: 26px;
      left: 4px;
      position: absolute;
      transition: .4s;
      width: 26px;

      ${media.desktop`
        height: 14px;
        width: 14px;
        bottom: 3px;
        left: 7px;
      `}
    }
  }

  ${props => props.checked && css`
    .slider {
      background-color: ${props => props.color ? variables[props.color] : '#66bb6a'};

      &:before {
        transform: translateX(26px);
        background-color: ${variables.white};
        ${media.desktop`
          transform: translateX(33px);
        `}
      }
    }
  `}
`;

const NewCheckoutContainer = styled.div`
  display: flex;
  justify-content: space-between;
  .switch {
    display: inline-block;
    height: auto;
    position: relative;
    width: auto;
    svg {
      position: absolute;
      top: 1.5px;
      left: 2.5px;
      path {
        fill: #d9d9d9;
      }
    }
  }

  .switch input {
    display:none;
  }

  .slider {
    background-color: ${props => props.color ? '#d9d9d9' : '#ccc'};
    bottom: 0;
    cursor: pointer;
    width: 16px;
    height: 16px;
    padding: 3px 3px 2px;
    border-radius: 2px;
    margin-right: 10px;
    transition: .4s;
  }

  ${props => props.checked && css`
    .switch {
      svg {
        path {
          fill: white;
        }
      }
    }
    .slider {
      background-color: ${props => props.color ? variables[props.color] : '#66bb6a'};
    }
  `}
  ${({ disabled }) => disabled && `
    pointer-events: none;
    &:hover {
      cursor: initial;
    }
      p {
        color: #C2C2C2 !important;
      }
    
    .slider {
      background-color: #C2C2C2 !important;  
    }
  `} 

	${({ outline }) => outline && `
		.slider {
			border: 1px solid black !important;
			background-color: white !important;
		}

		svg {
			display: none;
		}
	`}
`;

const CheckBoxToggle = ({
	onChange,
	checked,
	name,
	color,
	className,
	id,
	medCheckout,
	disabled,
	outline,
}) => {

	if (medCheckout) {
		return (
			<NewCheckoutContainer
				color={color}
				className={className}
				checked={checked}
				disabled={disabled}
				outline={outline}
			>
				<label className="switch" htmlFor={`${id}-checkbox`}>
					<input
						type="checkbox"
						id={`${id}-checkbox`}
						checked={checked}
						name={name}
						onChange={onChange}
					/>
					<CheckMark />
					<div className="slider" />
				</label>
			</NewCheckoutContainer>
		);
	}
	return (
		<Container
			color={color}
			className={className}
			checked={checked}
		>
			<label className="switch" htmlFor={`${id}-checkbox`}>
				<input
					type="checkbox"
					id={`${id}-checkbox`}
					checked={checked}
					name={name}
					onChange={onChange}
				/>
				<div className="slider" />
			</label>
		</Container>
	);
};

export default CheckBoxToggle;
